import { useEffect } from "react";
import FullScreenPanel from "app/ui/FullScreenPanel";
import { RoundType } from "app/game-data/useFetchGameData";
import useGameData from "app/game-data/useGameData";
import { useGameState } from "app/game/useGame";
import getInstructionsForRoundType from "app/instructions/getInstructionsForRoundType";

interface HowToPlayProps {
  onClose: () => void;
}

export default function HowToPlay(props: HowToPlayProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const gameData = useGameData();
  const gameState = useGameState();
  const round =
    gameData?.levels[gameState.roundIndex].levelType ?? RoundType.SPELLING_BEE;

  return (
    <FullScreenPanel
      className="bg-background"
      heading="How to Play"
      headingClassName="px-9 py-3"
      onClose={props.onClose}
    >
      <div className="flex flex-col gap-6 px-4 pb-14">
        <section className="contents">
          <ul className="list-disc ps-2">
            {getInstructionsForRoundType(round)}
          </ul>
          {/* <img className="mx-auto max-w-96" src={undefined} alt="" /> */}
        </section>
      </div>
    </FullScreenPanel>
  );
}
